module.exports = __webpack_public_path__ + "static/img/banner2.58916d19.png";